import type { AbstractIntlMessages } from 'use-intl';
import type { SupportedLocale } from '@/i18n/config';

/**
 * Lazy per-locale message loaders. `import.meta.glob` makes Vite emit one chunk
 * per `messages/*.json`, so only the active locale is fetched (the 8 files are
 * ~260 KB each; bundling all of them would be wasteful).
 */
const loaders = import.meta.glob<{ default: Record<string, unknown> }>('../../messages/*.json');

function loaderFor(locale: SupportedLocale) {
  const entry = Object.entries(loaders).find(([path]) => path.endsWith(`/${locale}.json`));
  return entry?.[1];
}

/** Load (and code-split) the message bundle for one locale. */
export async function loadMessages(locale: SupportedLocale): Promise<AbstractIntlMessages> {
  const loader = loaderFor(locale);
  if (!loader) {
    throw new Error(`No message bundle for locale "${locale}"`);
  }
  const mod = await loader();
  return mod.default as AbstractIntlMessages;
}
